var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4994 27L25.4998 22.5004C25.5 20.015 23.4852 18 20.9998 18H9.00069C6.51561 18 4.50097 20.0144 4.50069 22.4995L4.50018 27M19.5002 7.5C19.5002 9.98528 17.4855 12 15.0002 12C12.5149 12 10.5002 9.98528 10.5002 7.5C10.5002 5.01472 12.5149 3 15.0002 3C17.4855 3 19.5002 5.01472 19.5002 7.5Z",
    stroke: "#81BC3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/type.c92d0da2036baa46b5222688fdad95d1.svg";
export { ForwardRef as ReactComponent };